import React, { useContext, useEffect } from 'react'

import {
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader
} from '@clientbase/clientbase-library'
import { Box, Stack, Typography } from '@mui/material'
import { InvoiceParams } from 'models/Invoice'

import IconContainer from 'components/IconContainer/IconContainer'
import Steps from 'components/Steps'

import ButtonStep from './ButtonStep/ButtonStep'
import Confirmation from './Confirmation'
import { FormNegativationContext } from './context'
import Footer from './Footer'
import * as S from './FormNegativation.styles'
import Activation from './Steps/Activation'
import Revision from './Steps/Revision'
import Selection from './Steps/Selection'
import { STEPS } from './utils'

interface FormNegativationProps {
  invoice?: InvoiceParams
  handleCloseModal: () => void
  // SC-10999: seletor "Empresa" da criação na visão multi-empresas
  companySelector?: React.ReactNode
}

const FormNegativation: React.FC<FormNegativationProps> = ({
  invoice,
  handleCloseModal,
  companySelector
}) => {
  const { step, updateBillingSelected, updateInfosCustomer, updateStep } =
    useContext(FormNegativationContext)

  useEffect(() => {
    if (invoice) {
      updateBillingSelected(invoice)
      updateInfosCustomer(invoice?.customer)
      updateStep(1)
    }
  }, [invoice])

  return (
    <ModalBody>
      <ModalHeader onClose={handleCloseModal}>
        <Stack direction="row" alignItems="center" gap={2}>
          <IconContainer icon="thumbDownAlt" />
          <Typography variant="mdBold">Nova negativação</Typography>
        </Stack>
      </ModalHeader>

      <ModalContent>
        {/* A empresa é escolhida antes de selecionar a cobrança: depois disso
            a cobrança já define a empresa */}
        {step === 0 && companySelector}
        <S.Wrapper>
          <Box width="100%" maxWidth="400px" id="modal" pt={2}>
            <Steps steps={STEPS} activeStep={step} />
          </Box>
          <Selection />
          <Revision />
          <Activation />

          <Confirmation handleCloseModal={handleCloseModal} />
          <Footer />
        </S.Wrapper>
      </ModalContent>

      <ModalFooter>
        <ButtonStep />
      </ModalFooter>
    </ModalBody>
  )
}

export default FormNegativation
